import axios from './api';
import { getUrl } from './utils';
const endPoint = getUrl('api') + '/api/v2/elements';

export const getElements = async (pid) => {
  return axios.get(`${endPoint}`);
};
